import styled, { css } from "styled-components";
import { WhiteContainer, fontTitle, fontPrices, Title } from "../../theme/theme";
import { Share } from '../../components/share'
import { TextField, FormGroup } from "@material-ui/core";
import AccountCircle from '@material-ui/icons/AccountCircle';
import LocationOnIcon from '@material-ui/icons/LocationOn';


// Gris común para campos bloqueados (disabled o readOnly).
const lockedFieldStyle = css`
  &:disabled,
  &[readonly] {
    background-color: #f2f2f2;
    color: #999999;
    cursor: not-allowed;
    -webkit-text-fill-color: #999999;
    opacity: 1;
  }
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;

export const CartBody = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  ul {
    padding-left: 0em;
    margin: 0em 0em 0em 1.5em;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
    align-items: center;
  } ;
`;
export const CartSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  > div.parentContainer {
    width:100%;
  }
  > div.childContainer {
    width:65%;
    
   
     @media (max-width: 64em) and (max-height: 48em) {
      //1024
       width:60%;

    }
  
    @media (min-width: 80em) {
      //1200px
        width:60%;

    }

     @media (min-width: 112.5em) {
      //1800px
    width:65%;

    }
      

  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
      flex-direction: column;

      >div.childContainer {
        width: 100%;
        z-index: 100;
      }
  } ;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
      flex-direction: column;

      >div.childContainer {
        width: 100%;
      }
   }
  
`;

type CartContainerProps = {
  width?: string
}

export const CartContainer = styled(WhiteContainer)<CartContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  padding: 1em;
  margin: 0em;
  padding-bottom: 4em;
  box-sizing: border-box;
  box-shadow: none;
  background: #F9F9F9;
  max-width: ${props => props.width ?? '100%'};
  form {
    padding-bottom: 10px;
    width:100%;
    display: flex;
    flex-direction:column;
    justify-content: center;
    button {
        display: none;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
      button {
        display: inline;
      }
    }   
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
      margin: 2em 0em 2em 0em;
      max-width: 100%;
  } ;
`;

type Tcolor = {
  color: string;
}

export const ReturnLinkContainer = styled.div`
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 1rem;

  .return-link{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    color: ${props => props.theme.color};
  }
`

export const SummaryDetailList = styled.div<Tcolor>`
  display: flex;
  height: auto;
  padding: 1em 2em;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;

  .counter-products {
    margin-left: 20px;
    margin-top: 20px;
    color: rgba(153, 153, 153, 1);
  }
  .container-title {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    position: relative;
    padding: 1em 0em;
    .container-title {
      button{
        position: absolute;
      }
    }
    .counter-products {
      font-weight: 700;
      position: absolute;
      top: -4.5em;
      left: 0em;
      color: rgba(34, 34, 34, 1);
      .info {
        border-radius: 50%;
        color: white;
        width: 20px;
        height: 20px;
        /* color: white; */
        background: ${props => props.color};
        text-align: center;
      }
      .info::after{
        content: "!";
        display: flex;
        font-size: 16px;
        justify-content: center;
}


      }


    }
`
export const SummaryContainer = styled(WhiteContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5vh;
  margin: 2em 1em;
  flex: 0 0 auto;
  position: absolute;
`;
export const EmptyCart = styled.div`
    display: flex;    
    flex-direction: column;
    justify-content: center;
    padding: 5em;
    font-family: ${fontTitle};
    align-items: center;  
    svg{
      width: 60px;
      height: 65px;
    }

    div{
      margin: 5px;
    }
    button {
      margin-top:20px;
      font-family: ${fontPrices};
    }

    @media (max-width: ${props => props.theme.breakpoints.md}) {
      padding: 3em 1em;
    }
`
type checkEmpty = {
  isEmpty: boolean
}


export const TitleSummaryCart = styled(Title)<checkEmpty>`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    position: relative;
    margin-top: 0em;
    display: ${props => props.isEmpty ? 'none' : 'block'};
    margin-left: 0em;
    width: 100%;
  
    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      margin-bottom: 1rem;
     }
}
`

export const TitleShoppingCart = styled.div<checkEmpty>`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    /* margin-top: 0em;
    display: ${props => props.isEmpty ? 'none' : 'block'};
    margin-left: 0em;
    width: 100%; */
    
}
`

export const ShareCart = styled(Share)`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    position: absolute;
    
    
}
`

export const CartProductsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 1rem 0;
`;

export const CartProductsWithNotice = styled.div`
    border-bottom: 2px solid #D3D3D3;

    #product-row:last-child {
        border-bottom: 0;
    }

    & > ${CartProductsContainer} {
        padding-bottom: 0;
    }

    & > :last-child {
        margin-top: 8px;
    }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0em 3rem;
  padding-bottom: 1em;
  
  @media (max-width: 992px) {
    background-color: white;
    padding: 1rem;
  }
`;

export const MainHeadingForm = styled.p`
  font-family: Raleway;
  font-size: 35px;
  padding: 0 2rem;
  @media (max-width: 400px) {
    font-size: 8vmin; 
    padding: 0 1rem;
  } 
`;

type color = {
  color: string,
  opacity?: boolean
}


export const SpanHeadingForm = styled.span<color>`
  border-bottom: 1px solid ${props => props.color};
  padding-bottom: 10px;
  @media (max-width: 380px) {
    padding-bottom: 2px;
  } 
`;

export const SpanInputFormOne = styled.span`
  margin-left: 4%;
  margin-right: 4%;
  font-size: 22px;
`;
export const SpanInputFormTwo = styled.span`
  margin-left: 4%;
  margin-right: 4%;
  font-size: 22px;
  @media (max-width: 992px) {
    display: none;
  } ;
`;

export const SecondParragraph = styled.p<color>`
  color: #000;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.3rem;
  opacity: ${props => props.opacity ? 0.4 : 1 };
  & span {
    background: ${props => props.color && !props.opacity ? props.color : '#D3D3D3'};
    border-radius: 15px;
    color: #fff;
    height: 21px;
    width: 21px;
    display: inline-block;
    text-align: center;
    font-size: .9rem;
    margin-right: 8px;
  }
`;

export const ThirdParragraph = styled.p`
  font-weight: bold;
  font-family: "Open Sans";
`;
export const FourParragraph = styled.p`
  font-weight: bold;
  font-family: "Open Sans";
  margin-top: 25px;
`;

export const SecondDivForm = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: "space-between";
  @media (max-width: 992px) {
    flex-direction: column;
  } ;
`;
export const ThirdDivForm = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: "space-between";

  @media (max-width: 992px) {
    flex-direction: column;
  } ;
`;

export const FourDivForm = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: "space-between";
  align-items: center;
`;
export const FifthDivForm = styled.div`
  display: flex;
  @media (max-width: 992px) {
    flex-direction: column;
  } ;
`;

export const CountrySelectForm = styled.select`
margin-top: 20px;
padding: 10px;
border: 2px solid ${props => props.color};
border-radius: 8px;
flex: 1;
outline: none;
font-family: "Open Sans";
font-size: 18px;
color: #999999;
background-color: white;
${lockedFieldStyle}
@media (max-width: 992px) {
  margin-right: unset;
  border: none;
  border-bottom: 2px solid ${props => props.color};
  border-radius: unset;
  padding-left: 0;
}
`;

export const FirstSelectForm = styled.select`
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  flex: 1;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  ${lockedFieldStyle}
  @media (max-width: 992px) {
    margin-top: 20px;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  }
`;

export const SecondSelectForm = styled.select`
  margin-left: 30px;
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  flex: 1;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  ${lockedFieldStyle}

  @media (max-width: 992px) {
    margin-left: unset;
    margin-top: 20px;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;
export const ThirdSelectForm = styled.select`
  width: 40%;
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  ${lockedFieldStyle}
  @media (max-width: 992px) {
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;

interface TypeColor {
  color?: string;
}
export const NameInput = styled.input<TypeColor>`
  &:first-child{
    margin-right: 30px;
  }
  display: flex;
  width: 50%;
  font-size: 18px;
  font-family: "Open Sans";
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${props => props.color};
  color: #999999;
  outline: none;

  @media (max-width: 992px) {
    width: 100%;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
    margin-bottom: 1em;
  }

  ::placeholder {
    color: #999999;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999999;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #999999;
  }
  ${lockedFieldStyle}
`;
export const DetailsForm = styled.input`
  margin-top: 20px;
  font-size: 18px;
  font-family: "Open Sans";
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${props => props.color};
  @media (max-width: 992px) {
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
    margin-bottom: 1em;
  }
  color: #999999;
  outline: none;
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    height: auto;
  }
  ::placeholder {
    color: #999999;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999999;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #999999;
  }
  ${lockedFieldStyle}
`;

export const DetailsTextArea = styled.textarea`
  margin-top: 5px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Open Sans', Roboto, sans-serif;
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${(props: any) => props.color};
  width: 100%;
  box-sizing: border-box;
  resize: none;
  outline: none;
  color: #999999;
  @media (max-width: 992px) {
    border: none;
    border-bottom: 2px solid ${(props: any) => props.color};
    border-radius: unset;
    padding-left: 0;
    margin-bottom: 1em;
  }
  ::placeholder {
    color: #999999;
  }
  :-ms-input-placeholder {
    color: #999999;
  }
  ::-ms-input-placeholder {
    color: #999999;
  }
`;

export const DivForSpan1 = styled.div`
  display: flex;
`;
export const SpanOne = styled.span`
  width: 50%;
`;
export const SpanTwo = styled.span`
  width: 50%;
  margin-left: 30px;
`;

export const SpanFive = styled.span`
  width: 35%;
`;

export const SpanSix = styled.span`
  width: 75%;
`;

export const SpanSeven = styled.span`
  display: flex;
  flex: 1;
`;

export const SpanEight = styled.span`
  display: flex;
  flex: 1;
  margin-left: 30px;
`;
export const SpanNine = styled.span`
  width: 20%;
`;
export const SpanTen = styled.span`
  width: 21%;
  margin-left: 0;
`;
export const SpanEleven = styled.span`
  width: 19.5%;
  margin-left: 0;
`;
export const SpanTwelve = styled.span`
  width: 16%;
  margin-left: 0;
`;
export const SpanThirteen = styled.span`
  width: 20%;
  margin-left: 6px;
`;
export const SpanFourteen = styled.span`
  width: 18.5%;
  margin-left: 0;
`;

export const SpanThree = styled.span`
  width: 37%;
`;
export const SpanFour = styled.span`
  width: 37%;
`;
export const SpanFifteen = styled.span`
  width: 20%;
`;
export const PhoneInput = styled.input<TypeColor>`
  font-size: 18px;
  font-family: "Open Sans";
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${props => props.color};
  color: #999999;
  outline: none;
  margin-top: 20px;

  @media (max-width: 992px) {
    width: unset;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  }

  ::placeholder {
    color: #999999;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999999;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #999999;
  }
  ${lockedFieldStyle}
`;

export const EmailInput = styled.input<TypeColor>`
  width: 50%;
  font-size: 18px;
  font-family: "Open Sans";
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${props => props.color};
  color: #999999;
  outline: none;
  margin-left: 30px;

  @media (max-width: 992px) {
    margin-top: 20px;
    width: unset;
    margin-left: unset;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  }

  ::placeholder {
    color: #999999;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999999;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #999999;
  }
`;

export const DirectionInputOne = styled.input`
  width: 30%;
  padding: 10px;
  margin-left: 4%;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  @media (max-width: 992px) {
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;

export const DirectionInputTwo = styled.input`
  width: 30%;
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  @media (max-width: 992px) {
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;
export const DirectionInputFourth = styled.input`
  width: 30%;
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;

  @media (max-width: 992px) {
    width: 20%;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;

export const DirectionInputThird = styled.input`
  width: 46%;
  margin-left: 4%;
  padding: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 8px;
  outline: none;
  font-family: "Open Sans";
  font-size: 18px;
  color: #999999;
  background-color: white;
  @media (max-width: 992px) {
    width: 73%;
    border: none;
    border-bottom: 2px solid ${props => props.color};
    border-radius: unset;
    padding-left: 0;
  } ;
`;

export const StyledTextField = styled(TextField) <any>`
    width: ${props => props.loadClient ? '100%' : '80%'};
    & .MuiInputBase-adornedStart {
      height: 48px;
    };
    background: #F1F1F1;
    border-top-right-radius: ${props => props.loadClient ? 10 : 0}px;
    border-bottom-right-radius: ${props => props.loadClient ? 10 : 0}px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    ${props => props.loadClient ? 'border: none;' : ''}
    & fieldset {
      border-top-right-radius: ${props => props.loadClient ? 10 : 0}px;
      border-bottom-right-radius: ${props => props.loadClient ? 10 : 0}px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      line-height: 48px;
      height: 48px;
      margin-left: 0px !important;
      ${props => props.loadClient ? 'border: none;' : ''}
      & legend {
        margin: 0px !important;
      }
    }
`;

export const StyledFormGroup = styled(FormGroup) <any>`
  height: 48px;
`

export const ContainerAuthorize = styled.div<any>`
  margin-top: 20px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  & label{
      ${props => props.disabled ? 'opacity: .4;' : ''}
  }
`

export const ContainerNote = styled.div`
  margin-top: 10px;
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid rgba(0, 133, 255, 0.3);
  border-radius: 8px;
  padding: 0px 10px;
  & svg {
    margin-right: 10px;
  }
`

export const ContainerInputEmail = styled.div<any>`
  display: flex;
  & > div:first-child{
    width: ${(props) => props.widthProps};
    & > div:first-child{
      width: 100%;
    }
  }
  & > div:nth-child(2n){
    width: 20%;
    & button{
      width: 100%;
    }
  }
`

export const StyledAccountCircle = styled(AccountCircle)`
    width: 30px;
    height: 30px;

    path {
      width: 30px !important;
      height: 30px !important;
    }
`

export const StyledLocationOnIcon = styled(LocationOnIcon)`
    border-radius: 50%;
    background: ${props => props.htmlColor};
    width: 30px;
    height: 30px;

    path {
      fill: #F9F9F9;
      width: 30px !important;
      height: 30px !important;
    }
`

export const CartSummaryDetailBannerContainer = styled.div<{ $open?: boolean }>`
  @media (max-width: ${props => props.theme.breakpoints.md}){
    background-color: rgba(0, 0, 0, 0.10);
    ${props => props.$open ? `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1001;
      background: linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.10)), #F3F3F4;
    ` : ''}
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 66px;
    z-index: 150;
    
    cursor: pointer;

    & h3 {
      color: ${props => props.theme.color};
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      
      margin: 0 2px 0 10px;
    }

    & #cart-summary-banner-chevron-down {
      margin: 0 10px 0 2px;
    }

    & #cart-summary-banner-chevron-up {
      margin: 0 10px 0 2px;
    }

    & .cart-summary-banner__amount {
      color: var(--black-100, #000);
      text-align: center;
      font-family: Open Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: uppercase;

      margin: 0 5px 0 5px;
    }

  }
`

export const MarcaBlancaShippingTitle = styled.div`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    & ${TitleSummaryCart}, & ${TitleSummaryCart} span {
      font-size: 18px;
    }
  }
`;

// Título "Datos del comprador" del paso 3. El span no trae tamaño propio
// (hereda), así que se fija aquí sin tocar la clase compartida.
export const MarcaBlancaClientData = styled.div`
  margin: 2rem 0;

  & > span {
    color: #000000;
    font-family: 'Segoe UI', sans-serif;
    font-size: 24px;
    font-weight: 350;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 1.5rem 0;

    & > span {
      font-size: 18px;
    }
  }
`;

// Los términos usan TermsAndConditionsLabel
export const MarcaBlancaTermsScope = styled.div`
  & label {
    font-size: 16px;
    line-height: 1.5;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    & label {
      font-size: 14px;
    }
  }
`;

// Mismo caso con el botón de pago: CartPaymentButton
export const MarcaBlancaPayButtonScope = styled.div`
  & button {
    font-size: 18px;
    height: 67px;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    & button {
      font-size: 16px;
      height: 48px;
    }
  }
`;

// Paso 3 de Marca Blanca: la dirección de entrega es la de la sucursal elegida
// en el paso 2, así que se muestra como etiqueta fija y no como campo editable.
export const MarcaBlancaAddressBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  height: 67px;
  box-sizing: border-box;

  margin: 1rem 0;
  padding: 10px;

  background: #f1f1f1;
  border-radius: 10px;

  color: #5c5b5c;
  font-family: 'Segoe UI', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 100%;

  & > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: auto;
    min-height: 52px;
    font-size: 16px;
    line-height: 1.3;
  }
`;

export const MarcaBlancaDeliveryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin: 1.5rem 0;
`;

export const MarcaBlancaDeliveryOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  height: 56px;
  box-sizing: border-box;

  padding: 16px;

  background: #ffffff;
  border: 1px solid #F8F8F8;
  border-radius: 10px;

  cursor: pointer;

  & .marca-blanca-delivery__label {
    display: flex;
    align-items: center;
    gap: 12px;

    color: #000000;
    font-family: 'Segoe UI', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;

    input[type="radio"] {
      margin: 0;
      flex-shrink: 0;
    }
  }

  & .marca-blanca-delivery__price {
    color: #111928;
    font-family: 'Segoe UI', sans-serif;
    font-size: 16px;
    font-weight: 400;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: auto;
    min-height: 48px;
    padding: 12px;

    & .marca-blanca-delivery__label,
    & .marca-blanca-delivery__price {
      font-size: 14px;
    }
  }
`;

export const AddresInfoContainer = styled.div<{ showModal: boolean }>`
  @media (max-width: ${props => props.theme.breakpoints.md}){    
    /* margin-top: ${props => (props.showModal ? '70vh': '0')};  */
    z-index: 1;
  }   
`